import React from "react";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { downloadData } from '../../../../utilities/utilities';

var options = {
    fileName: 'exportData',
    fileType: "csv",
    separator: ","
}

const FilterComponent = ({ filterText, onFilter, onClear, data, columns, showDownload }) => (
  <Container fluid className='p-0' >
    <Row style={{alignItems:'baseline'}}>
        <Col className='p-0' xs={showDownload ? 11 : 12}>
            <Form.Control as='input' id="search" type="search" placeholder="Quick filter" aria-label="Search Input" value={filterText} onChange={onFilter} />
        </Col>
        {showDownload && <Col className='p-0' xs={1}>
            <i style={{float:'right'}} variant="primary" className='fa fa-download fa-lg' onClick={() => { downloadData(data, columns, options, callback => () => {})} }/>
            {/* <i style={{float:'right'}} variant="primary" className='fa fa-download fa-lg' onClick={() => { alert('hi') } }/> */}
        </Col>}
    </Row>
  </Container>
);

const OverviewPanelSearchWrapper = (props) => {
  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const filteredItems = filterText.length > 0 ? props.data.filter(item => {       
            return props.columns.some(col => {
                return item[col.selector] && item[col.selector].toString().toLowerCase().includes(filterText.toLowerCase())
            }) ? item : null
        }
  ) : props.data;

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} data={props.data} columns={props.panelColumns} showDownload={props.showDownload ?? true}/>;
  }, [filterText, resetPaginationToggle, props.data]);

  return (
    <div>
      {props.children(
        filteredItems,
        resetPaginationToggle,
        subHeaderComponentMemo
      )}
    </div>
  );
};

export default OverviewPanelSearchWrapper;
